export enum UserAccessEnum {
  SaveMyProfile = 1,
  ManageUsers = 2
}
